import React from "react";

const Pagination = ({ postPerPage, totalPost, paginate }) => {
  const pageNumber = [];
  for (let i = 1; i <= Math.ceil(totalPost / postPerPage); i++) {
    pageNumber.push(i);
  }

  return (
    <nav>
      <ul className='pagination'>
        {pageNumber.map((page) => (
          <li className='page-item' key={page}>
            <a
              className='page-link md:p-6 xs:p-2 cursor-pointer'
              href
              onClick={() => paginate(page)}>
              <span className='text-color flex items-center justify-center font-bold'>
                {page}
              </span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Pagination;
